<template>
  <div class="page-wrapper">
    <h1 class="home-page-title">{{ appTitle }}</h1>
    

  <!--  
    <a
      rel="noopener"
      class="documentation-link"
      target="_blank"
      href="/products"
      >
      
      Affirmations
  
      What Are Affirmations?
Affirmations are positive statements that can help you to challenge and overcome self-sabotaging  and negative thoughts. When you repeat them often, and believe in them, you can start to make positive changes. 
  
    →</a>
   -->
<div v-if="this.products">
   {{goRandomURL(this.products[Math.floor(Math.random() * this.products.length)].id)}}
</div>

  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  head() {
    return {
      title: {
        inner: 'Home'
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc'
        }
      ]
    }
  },
  computed: { ...mapState('app', ['appTitle']), ...mapState('products', ['products']),
   },
  methods: { 
     goRandomURL(val) {
      const id = `products/${val}`;
      this.$router.push(id)
    },  
  }   
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.page-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo {
    margin-bottom: 3rem;
  }

  .home-page-title {
    text-align: center;
  }

  .documentation-link {
    display: inline-block;
    font-size: 1.2rem;
    color: #fff;
    background-color: #5d6788;
    padding: 0.8rem 1.6rem;
    border-radius: 4px;
    transition: background-color 0.1s ease;
    box-sizing: border-box;
    text-decoration: none;
    width: fit-content;
    font-weight: 500;
  }
}
</style>
